<template>
  <CForm @submit="submit">
    <CModal :title="$t('pauseTimeRegistrationModal.title')" @close="close">
      <template #body>
        <CBooleanRadioField v-model="formData.isShort" :label="$t('pauseTimeRegistrationModal.willContinue')" required/>

        <CField v-if="formData.isShort === false" v-model="formData.reason" type="radio" :options="pauseReasons"
                :label="$t('pauseTimeRegistrationModal.pauseReason')" required>
          <template #option="{ option }">
            {{ option.description }}
          </template>
        </CField>
      </template>
    </CModal>
  </CForm>
</template>

<script setup lang="ts">
  import { computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import CModal from '@/general/components/CModal.vue';
  import Modals from '@/general/services/Modals';
  import CBooleanRadioField from '@/shared/components/form/CBooleanRadioField.vue';
  import CField from '@/shared/components/form/CField.vue';
  import CForm from '@/shared/components/form/CForm.vue';
  import Tag from '@/shared/models/Tag';
  import Job from '../models/Job';
  import JobContext from '../models/JobContext';
  import { TimeRegistrationId } from '../models/TimeRegistration';
  import JobService from '../services/JobService';
  import TimeRegistrationService from '../services/TimeRegistrationService';

  const props = defineProps<{
    jobs: Array<Job>,
    timeRegistrationId: TimeRegistrationId,
    context: JobContext,
  }>();

  const emit = defineEmits<{ (e: 'close'): void }>();

  const i18n = useI18n();

  const formData = reactive({
    isShort: null as boolean | null,
    reason: null as Tag | null,
  });

  const pauseReasons = computed(() => {
    return JobService.getPauseReasons();
  });

  async function submit() {
    const reason = formData.isShort ? null : formData.reason;
    const hasAllJobsStopped = await TimeRegistrationService.stop(props.timeRegistrationId, props.jobs, props.context, reason);
    close();
    if (!hasAllJobsStopped) await Modals.message(i18n.t('timeRegistrationModal.notAllJobsStopped'));
  }

  function close() {
    emit('close');
  }
</script>